import { MINUTE_IN_MS } from './time';

export const TASK_UPDATES_CACHE_TTL_MS = 2 * MINUTE_IN_MS;
export const TASK_USERS_CACHE_TTL_MS = 10 * MINUTE_IN_MS;
export const TASK_SPACES_CACHE_TTL_MS = 10 * MINUTE_IN_MS;
